/**
 * Runtime configuration. The legacy admin hardcoded these in `app.config.ts` and
 * `plugins/socket.ts`, which made pointing at a dev API a source edit; here they
 * come from the environment with production as the fallback.
 */

function required(value: string | undefined, name: string, fallback: string): string {
    if (value && value.length > 0) return value.replace(/\/+$/, '')
    if (import.meta.env.DEV) {
        console.warn(`[env] ${name} is not set; falling back to ${fallback}`)
    }
    return fallback
}

export const env = {
    apiUrl: required(import.meta.env.VITE_API_URL, 'VITE_API_URL', 'https://api.packs.com'),
    wsUrl: required(import.meta.env.VITE_WS_URL, 'VITE_WS_URL', 'https://ws.packs.com'),
    /** The storefront. Used to build the redemption links printed on promo QR codes. */
    siteUrl: required(import.meta.env.VITE_SITE_URL, 'VITE_SITE_URL', 'https://packs.com')
} as const
